import React, { useEffect, useState } from 'react'
import CircleLoader from '../Loader/CircleLoader/CircleLoader';

import { RootState } from '../../store';
import abilityBuild from '../../shared/CASL/appAbility';
import { useSelector } from 'react-redux';
import { Tree, TreeSelectionKeys } from 'primereact/tree';
import filingPlanService from '../../services/filingPlan.service';
import TreeNode from 'primereact/treenode';
import { ContextualMenu, IContextualMenuItem, Text } from '@fluentui/react';
import { ITitolario } from '../../shared/interfaces';



export interface FilingPlanTreeProps {
    extraCssClass?: string,
    forceTreeRefresh?: boolean,
    readOnlyMode?: boolean,
    selectedFilingPlanKey?: string,
    loadingFilingPlan?: boolean
    onSelectFilingPlanHandler?: (titolario: ITitolario | undefined) => void
    onSelectFilingPlanKeyHandler?: (titolario: string | undefined) => void
    editFilingPlanNodeHandler?: () => void;
    deleteFilingPlanNodeHandler?: () => void;
    addForwardRuleHandler?: () => void;


}

type Props = FilingPlanTreeProps;

const FilingPlanTree: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectArxeiaConfigurations = (state: RootState) => state.sessionReducer.arxeiaConfigurations;
    const arxeiaConfigurations = useSelector(selectArxeiaConfigurations);

    const [filingPlanFlatArray, setFilingPlanFlatArray] = useState<ITitolario[]>([]);
    const [filingPlanNodes, setFilingPlanNodes] = useState<TreeNode[]>([]);
    const [filingPlanExpandedNodes, setFilingPlanExpandedNodes] = useState<any>();
    const [selectedFilingPlanKey, setSelectedFilingPlanKey] = useState<TreeSelectionKeys | undefined>(props.selectedFilingPlanKey);

    const [loadingFilingPlan, setLoadingFilingPlan] = useState<boolean>(false);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [contextMenuItems, setContextMenuItems] = useState<IContextualMenuItem[] | undefined>([]);
    const [menuPosition, setMenuPosition] = useState<any>(undefined);



    useEffect(() => {
        setLoadingFilingPlan(props.loadingFilingPlan!);
    }, [props.loadingFilingPlan]);

    useEffect(() => {
        getFilingPlan();
    }, [currentAoo, props.forceTreeRefresh, arxeiaConfigurations]);


    useEffect(() => {
        setSelectedFilingPlanKey(props.selectedFilingPlanKey);
        //setSelectedFilingPlanNode(props.selectedFilingPlanNodeProp);
    }, [props.selectedFilingPlanKey]);



    const getFilingPlan = () => {
        if (currentAoo && arxeiaConfigurations) {
            setLoadingFilingPlan(true);
            filingPlanService.getFilingPlan(currentAoo.id)
                .then(filingPlanNodes => {
                    let expandedNodes = {};
                    let filingPlanFlat: ITitolario[] = []
                    /// Rimappo le voci di titolario nel formato TreeNode di prime react, setto tutti i nodi come aperti 
                    /// e creo l'array filingPlanFlat che utilizzo per facilitare la ricerca di una voce nel titolario
                    let filingPlan = remapFilingPlanNodes(filingPlanNodes, expandedNodes, filingPlanFlat);

                    setFilingPlanFlatArray(filingPlanFlat);
                    setFilingPlanNodes(filingPlan);
                    setFilingPlanExpandedNodes(expandedNodes);
                    setLoadingFilingPlan(false);

                })
                .catch(error => {
                    setLoadingFilingPlan(false);
                });
        }
    }

    const remapFilingPlanNodes = (filingPlanList: ITitolario[], expandedNodes: any, filingPlanFlat: Partial<ITitolario>[]) => {
        let filingPlan = filingPlanList.map(filingPlanItem => {
            let itemLabel = `${filingPlanItem.indice} - ${filingPlanItem.titolo}`;
            let itemKey = filingPlanItem.label;



            if (filingPlanItem.children && filingPlanItem.children.length) {
                expandedNodes[itemKey] = true;
            }

            // creo newFilingPlanItem rimuovendo children e parentId da filingPlanItem, non servono per il titolario flat
            let { children, parentId, ...newFlatFilingPlanItem } = filingPlanItem;
            filingPlanFlat.push(newFlatFilingPlanItem);

            let filingPlanItemChildren = remapFilingPlanNodes(filingPlanItem.children, expandedNodes, filingPlanFlat)
            return { ...filingPlanItem, key: itemKey.toString(), label: itemLabel, children: filingPlanItemChildren }

        });
        return filingPlan;
    }

    const selectFilingPlanNodeHandler = (selectedKey, isFromContextMenu: boolean) => {
        if (!props.readOnlyMode) {

            // se cambio la voce di titolario
            if (selectedKey && selectedFilingPlanKey !== selectedKey) {

                let selected = filingPlanFlatArray.find(it =>  it.label === selectedKey);
                if (currentAoo && selected) {
                    setSelectedFilingPlanKey(selectedKey);

                    if (props.onSelectFilingPlanHandler)
                        /// Aggiorno lo stato nel parent component 
                        props.onSelectFilingPlanHandler(selected);

                    if (props.onSelectFilingPlanKeyHandler)
                        /// Aggiorno lo stato nel parent component 
                        props.onSelectFilingPlanKeyHandler(selectedKey);

                }
            }
            // se deseleziono la voce di titolario
            else if (!isFromContextMenu) {
                setSelectedFilingPlanKey(undefined);

                if (props.onSelectFilingPlanHandler)
                    /// Aggiorno lo stato nel parent component 
                    props.onSelectFilingPlanHandler(undefined);

                if (props.onSelectFilingPlanKeyHandler)
                    /// Aggiorno lo stato nel parent component 
                    props.onSelectFilingPlanKeyHandler(undefined);


            }
        }
    }

    // metodi gestione context menu 
    const onShowContextualMenu = (ev) => {
        ev.originalEvent.preventDefault();

        updateContextMenuFilingPlan();
        setShowContextualMenu(true);
        setMenuPosition(ev.originalEvent);

    };

    const updateContextMenuFilingPlan = () => {
        let menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'ITitolario')) {
            menuItems.push(
                {
                    key: 'modifica',
                    text: 'Modifica voce',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => {
                        props.editFilingPlanNodeHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('delete', 'ITitolario')) {
            menuItems.push(
                {
                    key: 'elimina',
                    text: 'Elimina voce',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        props.deleteFilingPlanNodeHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('create', 'IForwardRule')) {
            menuItems.push(
                {
                    key: 'add',
                    text: 'Aggiungi regola',
                    iconProps: { iconName: 'Add' },
                    onClick: () => {
                        props.addForwardRuleHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        setContextMenuItems(menuItems);
    }

    const onHideContextualMenu = () => {
        setShowContextualMenu(false);
        setContextMenuItems(undefined);
    };



    return (
        <div className={`filing-plan-tree ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loadingFilingPlan} />
            <div className={`position-relative my-scroll-div`}>

                {filingPlanNodes.length > 0 ?

                    <div className={`my-component-content`}>

                        <Tree
                            filter filterMode="strict"
                            filterPlaceholder="Inserire una voce di titolario"
                            value={filingPlanNodes}
                            expandedKeys={filingPlanExpandedNodes}
                            selectionMode="single"
                            selectionKeys={selectedFilingPlanKey}
                            onSelectionChange={e => selectFilingPlanNodeHandler(e.value, false)}
                            onToggle={e => setFilingPlanExpandedNodes(e.value)}
                            onContextMenuSelectionChange={e => selectFilingPlanNodeHandler(e.value, true)}
                            onContextMenu={e => onShowContextualMenu(e)}
                        />
                    </div>
                    :

                    <div style={{ marginTop: '10px' }}>
                        <Text>Nessuna voce di Titolario disponibile</Text>
                    </div>

                }

                {showContextualMenu &&
                    <ContextualMenu
                        items={contextMenuItems!}
                        hidden={!showContextualMenu}
                        target={menuPosition}
                        onItemClick={onHideContextualMenu}
                        onDismiss={onHideContextualMenu}
                    />
                }

            </div>


        </div>



    )
}
export default FilingPlanTree;
